/** Shared confirm-dialog chrome for Auto-tagging / Tagging Plan flows. */
export const AUTO_TAGGING_CONFIRM_DIALOG_PAPER_SX = {
  width: 600,
  height: 272,
  maxWidth: 600,
  borderRadius: "3px",
  boxSizing: "border-box" as const,
};

export const AUTO_TAGGING_CONFIRM_DIALOG_TITLE_SX = {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  fontFamily: '"Nunito Sans", sans-serif',
  fontSize: 18,
  lineHeight: "28px",
  color: "#172B4D",
  fontWeight: 400,
  pr: 1,
} as const;

export const AUTO_TAGGING_CONFIRM_DIALOG_BODY_SX = {
  fontFamily: '"Nunito Sans", sans-serif',
  fontSize: 14,
  lineHeight: "20px",
  color: "#172B4D",
} as const;

export const AUTO_TAGGING_CONFIRM_CANCEL_BUTTON_SX = {
  textTransform: "none" as const,
  fontFamily: '"Nunito Sans", sans-serif',
  fontSize: 14,
  fontWeight: 600,
  color: "#295EF1",
};

export const AUTO_TAGGING_CONFIRM_CONFIRM_BUTTON_SX = {
  textTransform: "none" as const,
  fontFamily: '"Nunito Sans", sans-serif',
  fontSize: 14,
  fontWeight: 600,
  boxShadow: "none",
};
